import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=00cc574c&scoped=true&"
import script from "./Documentation.vue?vue&type=script&lang=ts&"
export * from "./Documentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cc574c",
  null
  
)

export default component.exports